module.exports = __webpack_public_path__ + "img/129.80fb5a0b.jpg";